import { render, staticRenderFns } from "./shhf.vue?vue&type=template&id=48373132&scoped=true&"
import script from "./shhf.vue?vue&type=script&lang=js&"
export * from "./shhf.vue?vue&type=script&lang=js&"
import style0 from "./shhf.vue?vue&type=style&index=0&id=48373132&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48373132",
  null
  
)

export default component.exports